import { render, staticRenderFns } from "./gledit.vue?vue&type=template&id=61db0dce&scoped=true&"
import script from "./gledit.vue?vue&type=script&lang=js&"
export * from "./gledit.vue?vue&type=script&lang=js&"
import style0 from "./gledit.vue?vue&type=style&index=0&id=61db0dce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61db0dce",
  null
  
)

export default component.exports